const costAccountingQuestions = [

{
  question: "Cost accounting is mainly concerned with:",
  options: ["ascertaining and controlling costs", "recording financial transactions", "preparing balance sheets", "auditing accounts"],
  answer: "ascertaining and controlling costs"
},
{
  question: "Which of the following is a function of cost accounting?",
  options: ["cost control and decision making", "preparing financial statements", "tax computation", "external reporting"],
  answer: "cost control and decision making"
},
{
  question: "Prime cost consists of:",
  options: ["direct materials + direct labour + direct expenses", "materials + overheads", "labour + overheads", "total cost - profit"],
  answer: "direct materials + direct labour + direct expenses"
},
{
  question: "A company has direct materials GH¢5,000, direct labour GH¢3,000 and direct expenses GH¢2,000. Prime cost is:",
  options: ["GH¢10,000", "GH¢8,000", "GH¢7,000", "GH¢6,000"],
  answer: "GH¢10,000"
},
{
  question: "Which of the following is an indirect cost?",
  options: ["factory rent", "raw materials", "direct labour", "direct expenses"],
  answer: "factory rent"
},
{
  question: "Fixed cost is best described as cost that:",
  options: ["remains constant regardless of output", "changes with output", "varies per unit", "is unpredictable"],
  answer: "remains constant regardless of output"
},
{
  question: "Variable cost per unit is:",
  options: ["constant", "increasing always", "decreasing always", "fixed"],
  answer: "constant"
},
{
  question: "Semi-variable cost contains:",
  options: ["both fixed and variable elements", "fixed cost only", "variable cost only", "direct cost only"],
  answer: "both fixed and variable elements"
},
{
  question: "A cost that can be traced directly to a product is:",
  options: ["direct cost", "indirect cost", "fixed cost", "period cost"],
  answer: "direct cost"
},
{
  question: "Which of the following is NOT a direct cost?",
  options: ["factory supervisor salary", "direct labour", "direct materials", "direct expenses"],
  answer: "factory supervisor salary"
},
{
  question: "Conversion cost is:",
  options: ["direct labour + overheads", "materials + labour", "total cost - profit", "labour only"],
  answer: "direct labour + overheads"
},
{
  question: "A company has direct labour GH¢4,000 and overheads GH¢6,000. Conversion cost is:",
  options: ["GH¢10,000", "GH¢6,000", "GH¢4,000", "GH¢2,000"],
  answer: "GH¢10,000"
},
{
  question: "Total cost is calculated as:",
  options: ["prime cost + overheads", "direct cost only", "fixed cost only", "sales - profit"],
  answer: "prime cost + overheads"
},
{
  question: "If prime cost is GH¢8,000 and overheads GH¢4,000, total cost is:",
  options: ["GH¢12,000", "GH¢4,000", "GH¢8,000", "GH¢10,000"],
  answer: "GH¢12,000"
},
{
  question: "Which cost is irrelevant for decision making?",
  options: ["sunk cost", "variable cost", "incremental cost", "relevant cost"],
  answer: "sunk cost"
},
{
  question: "Opportunity cost is:",
  options: ["benefit of next best alternative forgone", "total cost incurred", "fixed cost", "variable cost"],
  answer: "benefit of next best alternative forgone"
},
{
  question: "A cost that changes due to decision is:",
  options: ["relevant cost", "historical cost", "sunk cost", "fixed cost"],
  answer: "relevant cost"
},
{
  question: "Which of the following is a product cost?",
  options: ["direct materials", "administration expenses", "selling expenses", "distribution cost"],
  answer: "direct materials"
},
{
  question: "Which of the following is a period cost?",
  options: ["administrative expenses", "direct labour", "direct materials", "factory overhead"],
  answer: "administrative expenses"
},
{
  question: "If total cost is GH¢15,000 and profit GH¢5,000, sales is:",
  options: ["GH¢20,000", "GH¢10,000", "GH¢15,000", "GH¢5,000"],
  answer: "GH¢20,000"
},
{
  question: "Direct labour is classified under:",
  options: ["prime cost", "overhead", "fixed cost", "period cost"],
  answer: "prime cost"
},
{
  question: "Factory overhead includes:",
  options: ["indirect materials", "direct labour", "direct expenses", "prime cost"],
  answer: "indirect materials"
},
{
  question: "Which cost is controllable by management?",
  options: ["controllable cost", "uncontrollable cost", "fixed cost", "historical cost"],
  answer: "controllable cost"
},
{
  question: "Which cost cannot be changed by management in short term?",
  options: ["uncontrollable cost", "variable cost", "direct cost", "incremental cost"],
  answer: "uncontrollable cost"
},
{
  question: "A company has direct materials GH¢6,000, direct labour GH¢2,000, overheads GH¢3,000. Total cost is:",
  options: ["GH¢11,000", "GH¢8,000", "GH¢9,000", "GH¢10,000"],
  answer: "GH¢11,000"
},
{
  question: "Cost centre refers to:",
  options: ["a unit where cost is accumulated", "profit unit", "sales department", "market segment"],
  answer: "a unit where cost is accumulated"
},
{
  question: "Cost unit is:",
  options: ["unit of product or service", "cost centre", "overhead", "expense"],
  answer: "unit of product or service"
},
{
  question: "A cost driver is:",
  options: ["factor causing change in cost", "total cost", "fixed cost", "profit"],
  answer: "factor causing change in cost"
},
{
  question: "If variable cost per unit is GH¢5 and output is 1,000 units, total variable cost is:",
  options: ["GH¢5,000", "GH¢1,000", "GH¢500", "GH¢10,000"],
  answer: "GH¢5,000"
},
{
  question: "Which of the following best describes historical cost?",
  options: ["cost incurred in the past", "future cost", "estimated cost", "variable cost"],
  answer: "cost incurred in the past"
},

{
  question: "Economic Order Quantity (EOQ) is the quantity that:",
  options: ["minimizes total ordering and holding costs", "maximizes stock", "reduces demand", "increases storage"],
  answer: "minimizes total ordering and holding costs"
},
{
  question: "Reorder level is calculated as:",
  options: ["maximum usage × maximum lead time", "average usage × average lead time", "minimum usage × minimum lead time", "EOQ × lead time"],
  answer: "maximum usage × maximum lead time"
},
{
  question: "If maximum usage is 200 units and maximum lead time is 5 days, reorder level is:",
  options: ["1,000 units", "500 units", "200 units", "5 units"],
  answer: "1,000 units"
},
{
  question: "Minimum stock level is:",
  options: ["reorder level − (normal usage × normal lead time)", "maximum stock − reorder level", "EOQ − usage", "average stock"],
  answer: "reorder level − (normal usage × normal lead time)"
},
{
  question: "If reorder level is 1,000 units, normal usage 100 units, lead time 5 days, minimum stock is:",
  options: ["500 units", "1,000 units", "100 units", "600 units"],
  answer: "500 units"
},
{
  question: "Maximum stock level is:",
  options: ["reorder level + EOQ − (minimum usage × minimum lead time)", "reorder level − EOQ", "EOQ × usage", "average stock"],
  answer: "reorder level + EOQ − (minimum usage × minimum lead time)"
},
{
  question: "If reorder level = 1,000, EOQ = 600, minimum usage = 50, minimum lead time = 2, maximum stock is:",
  options: ["1,500 units", "1,400 units", "1,600 units", "1,300 units"],
  answer: "1,500 units"
},
{
  question: "EOQ formula is:",
  options: ["√(2DS/H)", "D/H", "2DS/H", "√(D/S)"],
  answer: "√(2DS/H)"
},
{
  question: "If annual demand is 2,000 units, ordering cost GH¢50, holding cost GH¢2, EOQ is:",
  options: ["316 units", "200 units", "100 units", "400 units"],
  answer: "316 units"
},
{
  question: "Average stock is calculated as:",
  options: ["(maximum + minimum)/2", "EOQ × 2", "reorder level × 2", "usage × time"],
  answer: "(maximum + minimum)/2"
},
{
  question: "FIFO method assumes:",
  options: ["first items purchased are issued first", "last items issued first", "average cost used", "random selection"],
  answer: "first items purchased are issued first"
},
{
  question: "AVCO method calculates:",
  options: ["weighted average cost", "last purchase cost", "first purchase cost", "standard cost"],
  answer: "weighted average cost"
},
{
  question: "Opening stock: 100 units @ GH¢5, purchase: 100 units @ GH¢7. AVCO price per unit is:",
  options: ["GH¢6", "GH¢5", "GH¢7", "GH¢6.5"],
  answer: "GH¢6"
},
{
  question: "Under FIFO, closing stock consists of:",
  options: ["latest purchases", "earliest purchases", "average cost", "fixed cost"],
  answer: "latest purchases"
},
{
  question: "A company purchases 100 units @ GH¢10 and later 100 units @ GH¢12. Issues 100 units. FIFO cost is:",
  options: ["GH¢1,000", "GH¢1,200", "GH¢1,100", "GH¢2,200"],
  answer: "GH¢1,000"
},
{
  question: "Closing stock under FIFO will be:",
  options: ["100 units @ GH¢12", "100 units @ GH¢10", "average cost", "zero"],
  answer: "100 units @ GH¢12"
},
{
  question: "Stock control helps to:",
  options: ["avoid overstocking and stockouts", "increase cost", "reduce efficiency", "limit production"],
  answer: "avoid overstocking and stockouts"
},
{
  question: "Lead time refers to:",
  options: ["time between order and delivery", "production time", "selling time", "storage time"],
  answer: "time between order and delivery"
},
{
  question: "Safety stock is maintained to:",
  options: ["prevent stockouts", "increase cost", "reduce inventory", "limit demand"],
  answer: "prevent stockouts"
},
{
  question: "Which cost is incurred when placing an order?",
  options: ["ordering cost", "holding cost", "production cost", "selling cost"],
  answer: "ordering cost"
},
{
  question: "Holding cost includes:",
  options: ["storage and insurance", "ordering expenses", "transport cost only", "production cost"],
  answer: "storage and insurance"
},
{
  question: "If ordering cost is GH¢100, demand 1,000 units, holding cost GH¢4, EOQ is:",
  options: ["224 units", "200 units", "250 units", "300 units"],
  answer: "224 units"
},
{
  question: "Which of the following increases EOQ?",
  options: ["higher demand", "higher holding cost", "lower ordering cost", "short lead time"],
  answer: "higher demand"
},
{
  question: "Which reduces EOQ?",
  options: ["higher holding cost", "higher demand", "higher ordering cost", "low storage"],
  answer: "higher holding cost"
},
{
  question: "If average usage is 80 units and average lead time is 4 days, reorder level (average method) is:",
  options: ["320 units", "80 units", "160 units", "400 units"],
  answer: "320 units"
},
{
  question: "Stockout cost refers to:",
  options: ["loss due to shortage of stock", "cost of storage", "ordering cost", "production cost"],
  answer: "loss due to shortage of stock"
},
{
  question: "Which method smooths price fluctuations?",
  options: ["AVCO", "FIFO", "specific identification", "standard cost"],
  answer: "AVCO"
},
{
  question: "If opening stock is 50 units @ GH¢8, purchase 50 units @ GH¢12, issue 50 units (FIFO), cost of issue is:",
  options: ["GH¢400", "GH¢600", "GH¢500", "GH¢800"],
  answer: "GH¢400"
},
{
  question: "Closing stock (FIFO) in above is:",
  options: ["50 units @ GH¢12", "50 units @ GH¢8", "average cost", "zero"],
  answer: "50 units @ GH¢12"
},
{
  question: "A business with poor stock control may face:",
  options: ["production delays", "high efficiency", "low cost always", "increased profit"],
  answer: "production delays"
},

{
  question: "Labour cost refers to:",
  options: ["cost of human effort in production", "cost of materials", "cost of machines", "overhead cost"],
  answer: "cost of human effort in production"
},
{
  question: "Time rate system pays workers based on:",
  options: ["hours worked", "units produced", "sales value", "profit"],
  answer: "hours worked"
},
{
  question: "Piece rate system pays workers based on:",
  options: ["output produced", "time spent", "salary grade", "position"],
  answer: "output produced"
},
{
  question: "A worker produces 200 units at GH¢2 per unit. Total wage is:",
  options: ["GH¢400", "GH¢200", "GH¢100", "GH¢600"],
  answer: "GH¢400"
},
{
  question: "A worker earns GH¢10 per hour and works 40 hours. Total wage is:",
  options: ["GH¢400", "GH¢300", "GH¢500", "GH¢200"],
  answer: "GH¢400"
},
{
  question: "Overtime premium is:",
  options: ["extra payment above normal rate", "basic wage", "bonus", "salary"],
  answer: "extra payment above normal rate"
},
{
  question: "A worker earns GH¢8/hour for 40 hours and GH¢12/hour for 10 overtime hours. Total wage is:",
  options: ["GH¢440", "GH¢400", "GH¢480", "GH¢500"],
  answer: "GH¢440"
},
{
  question: "Labour efficiency is measured as:",
  options: ["standard hours / actual hours × 100", "actual hours / standard hours × 100", "output × rate", "cost × output"],
  answer: "standard hours / actual hours × 100"
},
{
  question: "If standard hours = 50 and actual hours = 40, efficiency is:",
  options: ["125%", "80%", "100%", "75%"],
  answer: "125%"
},
{
  question: "A worker takes longer than standard time. Efficiency is:",
  options: ["less than 100%", "more than 100%", "equal to 100%", "zero"],
  answer: "less than 100%"
},
{
  question: "Labour turnover refers to:",
  options: ["rate of employees leaving and joining", "wage calculation", "working hours", "training cost"],
  answer: "rate of employees leaving and joining"
},
{
  question: "Labour turnover rate is calculated as:",
  options: ["number leaving / average workforce × 100", "total workforce × 100", "wages / labour", "output / labour"],
  answer: "number leaving / average workforce × 100"
},
{
  question: "If 20 workers leave out of average workforce of 200, turnover rate is:",
  options: ["10%", "5%", "20%", "15%"],
  answer: "10%"
},
{
  question: "High labour turnover may lead to:",
  options: ["high recruitment and training cost", "high efficiency", "low cost", "high profit"],
  answer: "high recruitment and training cost"
},
{
  question: "Idle time is:",
  options: ["time paid but not worked", "time worked", "overtime", "holiday"],
  answer: "time paid but not worked"
},
{
  question: "Idle time cost is treated as:",
  options: ["overhead", "direct labour", "prime cost", "fixed cost"],
  answer: "overhead"
},
{
  question: "Bonus system encourages:",
  options: ["higher productivity", "lower output", "inefficiency", "idle time"],
  answer: "higher productivity"
},
{
  question: "Gross wage includes:",
  options: ["basic pay + overtime + bonuses", "basic pay only", "net pay", "salary only"],
  answer: "basic pay + overtime + bonuses"
},
{
  question: "Net wage is:",
  options: ["gross wage minus deductions", "gross wage only", "bonus only", "overtime only"],
  answer: "gross wage minus deductions"
},
{
  question: "If gross wage is GH¢500 and deductions GH¢100, net wage is:",
  options: ["GH¢400", "GH¢500", "GH¢300", "GH¢600"],
  answer: "GH¢400"
},
{
  question: "Labour cost per unit is:",
  options: ["total labour cost / units produced", "units / cost", "cost × units", "profit / labour"],
  answer: "total labour cost / units produced"
},
{
  question: "If total labour cost is GH¢2,000 and output 500 units, cost per unit is:",
  options: ["GH¢4", "GH¢2", "GH¢5", "GH¢6"],
  answer: "GH¢4"
},
{
  question: "Which wage system is best for encouraging output?",
  options: ["piece rate", "time rate", "salary", "fixed wage"],
  answer: "piece rate"
},
{
  question: "Which system provides income stability?",
  options: ["time rate", "piece rate", "bonus system", "commission"],
  answer: "time rate"
},
{
  question: "Overtime is usually paid at:",
  options: ["higher rate than normal", "same rate", "lower rate", "zero"],
  answer: "higher rate than normal"
},
{
  question: "Labour cost directly traceable to product is:",
  options: ["direct labour", "indirect labour", "overhead", "fixed cost"],
  answer: "direct labour"
},
{
  question: "Supervisor salary is:",
  options: ["indirect labour", "direct labour", "prime cost", "variable cost"],
  answer: "indirect labour"
},
{
  question: "Payroll includes:",
  options: ["record of wages and salaries", "stock record", "sales record", "cost sheet"],
  answer: "record of wages and salaries"
},
{
  question: "If a worker earns GH¢15/hour and works 30 hours, wage is:",
  options: ["GH¢450", "GH¢300", "GH¢500", "GH¢600"],
  answer: "GH¢450"
},
{
  question: "A company reducing idle time will:",
  options: ["reduce cost", "increase cost", "reduce output", "increase waste"],
  answer: "reduce cost"
},

{
  question: "Overheads are:",
  options: ["indirect costs of production", "direct costs", "prime costs", "fixed costs only"],
  answer: "indirect costs of production"
},
{
  question: "Which of the following is an overhead cost?",
  options: ["factory rent", "direct labour", "raw materials", "direct expenses"],
  answer: "factory rent"
},
{
  question: "Allocation of overhead means:",
  options: ["assigning cost directly to a cost centre", "sharing cost among departments", "estimating cost", "ignoring cost"],
  answer: "assigning cost directly to a cost centre"
},
{
  question: "Apportionment means:",
  options: ["sharing overhead among cost centres", "assigning direct cost", "ignoring cost", "adding profit"],
  answer: "sharing overhead among cost centres"
},
{
  question: "Which cost is apportioned?",
  options: ["electricity cost", "direct labour", "raw materials", "direct expenses"],
  answer: "electricity cost"
},
{
  question: "Floor area is used as basis for apportioning:",
  options: ["rent", "electricity", "labour", "materials"],
  answer: "rent"
},
{
  question: "Number of employees is basis for:",
  options: ["canteen cost", "rent", "machine cost", "materials"],
  answer: "canteen cost"
},
{
  question: "Machine hours is used to apportion:",
  options: ["machine-related costs", "rent", "labour", "materials"],
  answer: "machine-related costs"
},
{
  question: "Overhead Absorption Rate (OAR) is:",
  options: ["overheads / activity base", "profit / cost", "cost / output", "sales / labour"],
  answer: "overheads / activity base"
},
{
  question: "If overhead is GH¢10,000 and machine hours 2,000, OAR is:",
  options: ["GH¢5 per hour", "GH¢2 per hour", "GH¢10 per hour", "GH¢20 per hour"],
  answer: "GH¢5 per hour"
},
{
  question: "Which base is used for labour-intensive production?",
  options: ["labour hours", "machine hours", "units", "sales"],
  answer: "labour hours"
},
{
  question: "Which base is used for machine-intensive production?",
  options: ["machine hours", "labour hours", "units", "sales"],
  answer: "machine hours"
},
{
  question: "If overhead GH¢8,000 and labour hours 1,000, OAR is:",
  options: ["GH¢8/hour", "GH¢10/hour", "GH¢6/hour", "GH¢5/hour"],
  answer: "GH¢8/hour"
},
{
  question: "Absorbed overhead is:",
  options: ["OAR × actual activity", "total overhead", "fixed cost", "variable cost"],
  answer: "OAR × actual activity"
},
{
  question: "If OAR = GH¢5/hour and actual hours = 1,500, absorbed overhead is:",
  options: ["GH¢7,500", "GH¢5,000", "GH¢6,000", "GH¢8,000"],
  answer: "GH¢7,500"
},
{
  question: "Under-absorption occurs when:",
  options: ["absorbed overhead < actual overhead", "absorbed > actual", "equal", "zero"],
  answer: "absorbed overhead < actual overhead"
},
{
  question: "Over-absorption occurs when:",
  options: ["absorbed overhead > actual overhead", "absorbed < actual", "equal", "zero"],
  answer: "absorbed overhead > actual overhead"
},
{
  question: "If actual overhead GH¢9,000 and absorbed GH¢7,500, under-absorption is:",
  options: ["GH¢1,500", "GH¢2,000", "GH¢500", "GH¢1,000"],
  answer: "GH¢1,500"
},
{
  question: "If absorbed GH¢10,000 and actual GH¢8,000, over-absorption is:",
  options: ["GH¢2,000", "GH¢1,000", "GH¢3,000", "GH¢500"],
  answer: "GH¢2,000"
},
{
  question: "Service department provides:",
  options: ["support to production departments", "direct production", "sales", "marketing"],
  answer: "support to production departments"
},
{
  question: "Re-apportionment is:",
  options: ["redistribution of service department costs", "allocation", "costing", "budgeting"],
  answer: "redistribution of service department costs"
},
{
  question: "Which department is NOT production?",
  options: ["maintenance", "assembly", "fabrication", "processing"],
  answer: "maintenance"
},
{
  question: "Overhead absorption helps to:",
  options: ["determine product cost", "increase profit", "reduce cost", "control labour"],
  answer: "determine product cost"
},
{
  question: "Primary distribution involves:",
  options: ["allocation and apportionment", "re-apportionment", "absorption", "budgeting"],
  answer: "allocation and apportionment"
},
{
  question: "Secondary distribution involves:",
  options: ["re-apportionment", "allocation", "budgeting", "pricing"],
  answer: "re-apportionment"
},
{
  question: "Which method redistributes service costs step-by-step?",
  options: ["step method", "direct method", "absorption method", "allocation method"],
  answer: "step method"
},
{
  question: "Which method ignores inter-service relationships?",
  options: ["direct method", "step method", "reciprocal method", "absorption method"],
  answer: "direct method"
},
{
  question: "Overhead cost per unit is:",
  options: ["total overhead / output", "output × cost", "profit / cost", "sales / output"],
  answer: "total overhead / output"
},
{
  question: "If overhead GH¢12,000 and output 3,000 units, overhead per unit is:",
  options: ["GH¢4", "GH¢3", "GH¢5", "GH¢6"],
  answer: "GH¢4"
},
{
  question: "Proper overhead allocation leads to:",
  options: ["accurate product costing", "higher cost", "losses", "inefficiency"],
  answer: "accurate product costing"
},

{
  question: "Job costing is used when:",
  options: ["each job is unique", "production is continuous", "goods are identical", "mass production"],
  answer: "each job is unique"
},
{
  question: "Batch costing is suitable for:",
  options: ["production in batches", "continuous production", "service industry", "construction only"],
  answer: "production in batches"
},
{
  question: "Process costing is used when:",
  options: ["production is continuous", "jobs are unique", "output varies", "services only"],
  answer: "production is continuous"
},
{
  question: "Contract costing is used for:",
  options: ["large construction projects", "small jobs", "retail business", "service firms"],
  answer: "large construction projects"
},
{
  question: "A job has direct materials GH¢5,000, labour GH¢3,000, overhead GH¢2,000. Total cost is:",
  options: ["GH¢10,000", "GH¢8,000", "GH¢7,000", "GH¢9,000"],
  answer: "GH¢10,000"
},
{
  question: "If profit is 20% of cost and cost is GH¢10,000, selling price is:",
  options: ["GH¢12,000", "GH¢10,000", "GH¢8,000", "GH¢15,000"],
  answer: "GH¢12,000"
},
{
  question: "Batch cost per unit is:",
  options: ["total batch cost / units", "units × cost", "cost × profit", "sales / units"],
  answer: "total batch cost / units"
},
{
  question: "If batch cost is GH¢5,000 for 500 units, cost per unit is:",
  options: ["GH¢10", "GH¢5", "GH¢8", "GH¢12"],
  answer: "GH¢10"
},
{
  question: "In job costing, cost is accumulated for:",
  options: ["each job separately", "all production together", "departments", "products"],
  answer: "each job separately"
},
{
  question: "Which costing method uses job cards?",
  options: ["job costing", "process costing", "batch costing", "contract costing"],
  answer: "job costing"
},
{
  question: "Contract costing includes:",
  options: ["long-term projects", "mass production", "retail goods", "small jobs"],
  answer: "long-term projects"
},
{
  question: "Work certified refers to:",
  options: ["completed portion approved", "unfinished work", "total work", "profit"],
  answer: "completed portion approved"
},
{
  question: "Retention money is:",
  options: ["money withheld until completion", "profit", "cost", "bonus"],
  answer: "money withheld until completion"
},
{
  question: "In process costing, output is:",
  options: ["continuous and identical", "unique", "customized", "varied"],
  answer: "continuous and identical"
},
{
  question: "Normal loss is:",
  options: ["expected loss in process", "unexpected loss", "avoidable loss", "profit"],
  answer: "expected loss in process"
},
{
  question: "Abnormal loss is:",
  options: ["unexpected loss", "normal loss", "profit", "cost"],
  answer: "unexpected loss"
},
{
  question: "If input = 1,000 units, normal loss 10%, expected output is:",
  options: ["900 units", "1,000 units", "100 units", "800 units"],
  answer: "900 units"
},
{
  question: "If actual output is 850 units, abnormal loss is:",
  options: ["50 units", "100 units", "150 units", "0"],
  answer: "50 units"
},
{
  question: "Process cost per unit is:",
  options: ["total process cost / output", "output × cost", "cost × units", "profit / units"],
  answer: "total process cost / output"
},
{
  question: "If process cost GH¢9,000 and output 900 units, cost per unit is:",
  options: ["GH¢10", "GH¢8", "GH¢12", "GH¢9"],
  answer: "GH¢10"
},
{
  question: "Equivalent units are used in:",
  options: ["process costing", "job costing", "batch costing", "contract costing"],
  answer: "process costing"
},
{
  question: "Work-in-progress refers to:",
  options: ["partially completed units", "finished goods", "raw materials", "waste"],
  answer: "partially completed units"
},
{
  question: "In contract costing, profit is recognized based on:",
  options: ["work certified", "total cost", "materials used", "labour"],
  answer: "work certified"
},
{
  question: "Which method is best for construction?",
  options: ["contract costing", "process costing", "batch costing", "job costing"],
  answer: "contract costing"
},
{
  question: "Cost sheet shows:",
  options: ["cost breakdown", "profit only", "sales only", "assets"],
  answer: "cost breakdown"
},
{
  question: "If cost GH¢20,000 and profit 25%, selling price is:",
  options: ["GH¢25,000", "GH¢20,000", "GH¢30,000", "GH¢15,000"],
  answer: "GH¢25,000"
},
{
  question: "Job costing helps to:",
  options: ["control cost per job", "increase production", "reduce labour", "control sales"],
  answer: "control cost per job"
},
{
  question: "Batch costing is a form of:",
  options: ["job costing", "process costing", "contract costing", "standard costing"],
  answer: "job costing"
},
{
  question: "Which costing method uses stages of production?",
  options: ["process costing", "job costing", "batch costing", "contract costing"],
  answer: "process costing"
},
{
  question: "Accurate costing methods lead to:",
  options: ["better pricing decisions", "higher costs", "lower output", "losses"],
  answer: "better pricing decisions"
},

{
  question: "Contribution is:",
  options: ["sales − variable cost", "sales − fixed cost", "profit − cost", "fixed cost − variable cost"],
  answer: "sales − variable cost"
},
{
  question: "If sales GH¢10,000 and variable cost GH¢6,000, contribution is:",
  options: ["GH¢4,000", "GH¢6,000", "GH¢10,000", "GH¢2,000"],
  answer: "GH¢4,000"
},
{
  question: "Profit is:",
  options: ["contribution − fixed cost", "sales − total cost", "fixed cost − variable cost", "sales − contribution"],
  answer: "contribution − fixed cost"
},
{
  question: "If contribution GH¢5,000 and fixed cost GH¢3,000, profit is:",
  options: ["GH¢2,000", "GH¢3,000", "GH¢5,000", "GH¢8,000"],
  answer: "GH¢2,000"
},
{
  question: "Break-even point is where:",
  options: ["profit = 0", "sales = 0", "cost = 0", "revenue = 0"],
  answer: "profit = 0"
},
{
  question: "Break-even point (units) =",
  options: ["fixed cost / contribution per unit", "sales / cost", "cost / sales", "profit / units"],
  answer: "fixed cost / contribution per unit"
},
{
  question: "If fixed cost GH¢10,000 and contribution per unit GH¢5, BEP (units) is:",
  options: ["2,000 units", "1,000 units", "500 units", "5,000 units"],
  answer: "2,000 units"
},
{
  question: "Contribution per unit is:",
  options: ["selling price − variable cost", "selling price − fixed cost", "profit − cost", "cost − price"],
  answer: "selling price − variable cost"
},
{
  question: "If selling price GH¢20 and variable cost GH¢12, contribution per unit is:",
  options: ["GH¢8", "GH¢12", "GH¢20", "GH¢10"],
  answer: "GH¢8"
},
{
  question: "Break-even sales (value) =",
  options: ["fixed cost / P/V ratio", "sales × cost", "cost / profit", "profit × cost"],
  answer: "fixed cost / P/V ratio"
},
{
  question: "P/V ratio is:",
  options: ["contribution / sales", "profit / cost", "sales / cost", "cost / sales"],
  answer: "contribution / sales"
},
{
  question: "If contribution GH¢4,000 and sales GH¢10,000, P/V ratio is:",
  options: ["40%", "50%", "20%", "60%"],
  answer: "40%"
},
{
  question: "If fixed cost GH¢8,000 and P/V ratio 40%, BEP (sales) is:",
  options: ["GH¢20,000", "GH¢10,000", "GH¢8,000", "GH¢12,000"],
  answer: "GH¢20,000"
},
{
  question: "Margin of safety is:",
  options: ["actual sales − break-even sales", "sales − cost", "profit − loss", "fixed − variable"],
  answer: "actual sales − break-even sales"
},
{
  question: "If actual sales GH¢25,000 and BEP GH¢20,000, margin of safety is:",
  options: ["GH¢5,000", "GH¢20,000", "GH¢25,000", "GH¢10,000"],
  answer: "GH¢5,000"
},
{
  question: "Margin of safety ratio =",
  options: ["margin of safety / actual sales", "sales / cost", "profit / sales", "cost / profit"],
  answer: "margin of safety / actual sales"
},
{
  question: "If margin GH¢5,000 and sales GH¢25,000, MOS ratio is:",
  options: ["20%", "25%", "10%", "30%"],
  answer: "20%"
},
{
  question: "A higher P/V ratio indicates:",
  options: ["higher profitability", "higher cost", "lower sales", "higher loss"],
  answer: "higher profitability"
},
{
  question: "If selling price increases and cost remains constant, contribution:",
  options: ["increases", "decreases", "remains same", "becomes zero"],
  answer: "increases"
},
{
  question: "If variable cost increases, contribution:",
  options: ["decreases", "increases", "remains same", "becomes zero"],
  answer: "decreases"
},
{
  question: "At break-even point, contribution equals:",
  options: ["fixed cost", "profit", "sales", "variable cost"],
  answer: "fixed cost"
},
{
  question: "A firm selling below BEP will:",
  options: ["incur loss", "make profit", "break even", "increase revenue"],
  answer: "incur loss"
},
{
  question: "Contribution helps to:",
  options: ["cover fixed cost and profit", "reduce cost", "increase labour", "control production"],
  answer: "cover fixed cost and profit"
},
{
  question: "If contribution per unit is GH¢6 and fixed cost GH¢12,000, BEP units:",
  options: ["2,000 units", "1,000 units", "3,000 units", "500 units"],
  answer: "2,000 units"
},
{
  question: "If sales GH¢30,000 and variable cost GH¢18,000, contribution is:",
  options: ["GH¢12,000", "GH¢18,000", "GH¢30,000", "GH¢10,000"],
  answer: "GH¢12,000"
},
{
  question: "If contribution GH¢12,000 and fixed cost GH¢10,000, profit is:",
  options: ["GH¢2,000", "GH¢10,000", "GH¢12,000", "GH¢22,000"],
  answer: "GH¢2,000"
},
{
  question: "If P/V ratio is 50% and sales GH¢20,000, contribution is:",
  options: ["GH¢10,000", "GH¢5,000", "GH¢20,000", "GH¢15,000"],
  answer: "GH¢10,000"
},
{
  question: "If BEP is 2,000 units and actual sales 3,000 units, margin of safety is:",
  options: ["1,000 units", "2,000 units", "500 units", "3,000 units"],
  answer: "1,000 units"
},
{
  question: "Which factor reduces break-even point?",
  options: ["increase in contribution per unit", "increase in fixed cost", "increase in variable cost", "decrease in selling price"],
  answer: "increase in contribution per unit"
},
{
  question: "Which factor increases break-even point?",
  options: ["increase in fixed cost", "increase in contribution", "increase in price", "decrease in cost"],
  answer: "increase in fixed cost"
},

{
  question: "A budget is best defined as:",
  options: ["a financial plan for a future period", "past financial record", "cost sheet", "profit statement"],
  answer: "a financial plan for a future period"
},
{
  question: "Budgetary control involves:",
  options: ["comparing actual performance with budget", "preparing accounts", "recording transactions", "auditing"],
  answer: "comparing actual performance with budget"
},
{
  question: "Flexible budget adjusts with:",
  options: ["level of activity", "fixed cost only", "sales only", "profit only"],
  answer: "level of activity"
},
{
  question: "Fixed budget is prepared for:",
  options: ["one level of activity", "all levels", "profit only", "sales only"],
  answer: "one level of activity"
},
{
  question: "If budgeted sales 1,000 units @ GH¢20, total sales is:",
  options: ["GH¢20,000", "GH¢10,000", "GH¢1,000", "GH¢2,000"],
  answer: "GH¢20,000"
},
{
  question: "A company budgets 2,000 units at GH¢5 variable cost. Total variable cost is:",
  options: ["GH¢10,000", "GH¢5,000", "GH¢2,000", "GH¢8,000"],
  answer: "GH¢10,000"
},
{
  question: "If fixed cost GH¢8,000 and variable cost GH¢10,000, total cost is:",
  options: ["GH¢18,000", "GH¢10,000", "GH¢8,000", "GH¢12,000"],
  answer: "GH¢18,000"
},
{
  question: "Variance is:",
  options: ["difference between actual and budget", "total cost", "sales value", "profit"],
  answer: "difference between actual and budget"
},
{
  question: "Favourable variance means:",
  options: ["actual better than budget", "actual worse", "equal", "zero"],
  answer: "actual better than budget"
},
{
  question: "Adverse variance means:",
  options: ["actual worse than budget", "actual better", "equal", "zero"],
  answer: "actual worse than budget"
},
{
  question: "If budget cost GH¢5,000 and actual GH¢4,500, variance is:",
  options: ["GH¢500 favourable", "GH¢500 adverse", "GH¢4,500", "GH¢5,000"],
  answer: "GH¢500 favourable"
},
{
  question: "If actual cost GH¢6,000 and budget GH¢5,000, variance is:",
  options: ["GH¢1,000 adverse", "GH¢1,000 favourable", "GH¢5,000", "GH¢6,000"],
  answer: "GH¢1,000 adverse"
},
{
  question: "Sales variance is:",
  options: ["difference between actual and budget sales", "cost difference", "profit difference", "labour cost"],
  answer: "difference between actual and budget sales"
},
{
  question: "If budget sales GH¢20,000 and actual GH¢25,000, variance is:",
  options: ["GH¢5,000 favourable", "GH¢5,000 adverse", "GH¢20,000", "GH¢25,000"],
  answer: "GH¢5,000 favourable"
},
{
  question: "Production budget is based on:",
  options: ["sales forecast", "cost only", "profit only", "labour"],
  answer: "sales forecast"
},
{
  question: "Cash budget shows:",
  options: ["cash inflows and outflows", "profit", "cost only", "sales"],
  answer: "cash inflows and outflows"
},
{
  question: "If opening cash GH¢2,000 and inflow GH¢5,000, outflow GH¢4,000, closing cash is:",
  options: ["GH¢3,000", "GH¢2,000", "GH¢1,000", "GH¢4,000"],
  answer: "GH¢3,000"
},
{
  question: "Zero-based budgeting starts from:",
  options: ["zero base", "previous budget", "profit level", "sales level"],
  answer: "zero base"
},
{
  question: "Which budget is prepared first?",
  options: ["sales budget", "production budget", "cash budget", "labour budget"],
  answer: "sales budget"
},
{
  question: "Flexible budget formula:",
  options: ["fixed cost + (variable cost × activity)", "sales − cost", "profit − cost", "fixed cost only"],
  answer: "fixed cost + (variable cost × activity)"
},
{
  question: "If fixed cost GH¢5,000 and variable GH¢4/unit, at 1,000 units total cost is:",
  options: ["GH¢9,000", "GH¢5,000", "GH¢4,000", "GH¢10,000"],
  answer: "GH¢9,000"
},
{
  question: "If output increases, variable cost:",
  options: ["increases", "decreases", "remains same", "zero"],
  answer: "increases"
},
{
  question: "If output increases, fixed cost:",
  options: ["remains same", "increases", "decreases", "zero"],
  answer: "remains same"
},
{
  question: "Budget helps management to:",
  options: ["plan and control", "increase cost", "reduce sales", "limit production"],
  answer: "plan and control"
},
{
  question: "Which budget is affected by production level?",
  options: ["flexible budget", "fixed budget", "cash budget", "sales budget"],
  answer: "flexible budget"
},
{
  question: "If budget output 1,000 units, actual 1,200 units, this shows:",
  options: ["increase in activity", "decrease in activity", "no change", "loss"],
  answer: "increase in activity"
},
{
  question: "Which budget focuses on income and expenses?",
  options: ["income budget", "cash budget", "production budget", "labour budget"],
  answer: "income budget"
},
{
  question: "A company exceeding budgeted sales is:",
  options: ["favourable", "adverse", "loss", "neutral"],
  answer: "favourable"
},
{
  question: "Budget control helps to:",
  options: ["detect inefficiencies", "increase cost", "reduce control", "ignore performance"],
  answer: "detect inefficiencies"
},
{
  question: "Effective budgeting requires:",
  options: ["accurate forecasting", "guesswork", "no planning", "random decisions"],
  answer: "accurate forecasting"
},

{
  question: "Standard cost is:",
  options: ["predetermined cost", "actual cost", "variable cost", "fixed cost"],
  answer: "predetermined cost"
},
{
  question: "Variance is:",
  options: ["difference between actual and standard", "total cost", "profit", "sales"],
  answer: "difference between actual and standard"
},
{
  question: "Material cost variance =",
  options: ["standard cost − actual cost", "actual − standard", "sales − cost", "profit − cost"],
  answer: "standard cost − actual cost"
},
{
  question: "If standard cost GH¢5,000 and actual GH¢5,500, variance is:",
  options: ["GH¢500 adverse", "GH¢500 favourable", "GH¢5,000", "GH¢5,500"],
  answer: "GH¢500 adverse"
},
{
  question: "Material price variance =",
  options: ["(standard price − actual price) × actual quantity", "price × quantity", "cost − profit", "sales − cost"],
  answer: "(standard price − actual price) × actual quantity"
},
{
  question: "If SP = GH¢5, AP = GH¢6, AQ = 1,000 units, MPV is:",
  options: ["GH¢1,000 adverse", "GH¢1,000 favourable", "GH¢5,000", "GH¢6,000"],
  answer: "GH¢1,000 adverse"
},
{
  question: "Material usage variance =",
  options: ["(standard quantity − actual quantity) × standard price", "price × quantity", "sales − cost", "profit − cost"],
  answer: "(standard quantity − actual quantity) × standard price"
},
{
  question: "If SQ = 1,000, AQ = 1,200, SP = GH¢5, usage variance is:",
  options: ["GH¢1,000 adverse", "GH¢1,000 favourable", "GH¢5,000", "GH¢6,000"],
  answer: "GH¢1,000 adverse"
},
{
  question: "Labour cost variance =",
  options: ["standard cost − actual cost", "actual − standard", "profit − cost", "sales − cost"],
  answer: "standard cost − actual cost"
},
{
  question: "Labour rate variance =",
  options: ["(standard rate − actual rate) × actual hours", "rate × hours", "cost − profit", "sales − cost"],
  answer: "(standard rate − actual rate) × actual hours"
},
{
  question: "If SR = GH¢10, AR = GH¢12, AH = 500, labour rate variance is:",
  options: ["GH¢1,000 adverse", "GH¢1,000 favourable", "GH¢5,000", "GH¢6,000"],
  answer: "GH¢1,000 adverse"
},
{
  question: "Labour efficiency variance =",
  options: ["(standard hours − actual hours) × standard rate", "rate × hours", "profit − cost", "sales − cost"],
  answer: "(standard hours − actual hours) × standard rate"
},
{
  question: "If SH = 400, AH = 500, SR = GH¢10, efficiency variance is:",
  options: ["GH¢1,000 adverse", "GH¢1,000 favourable", "GH¢5,000", "GH¢4,000"],
  answer: "GH¢1,000 adverse"
},
{
  question: "Favourable variance occurs when:",
  options: ["actual cost < standard cost", "actual > standard", "equal", "zero"],
  answer: "actual cost < standard cost"
},
{
  question: "Adverse variance occurs when:",
  options: ["actual cost > standard cost", "actual < standard", "equal", "zero"],
  answer: "actual cost > standard cost"
},
{
  question: "Standard costing helps to:",
  options: ["control cost", "increase cost", "reduce output", "ignore performance"],
  answer: "control cost"
},
{
  question: "Variance analysis helps management to:",
  options: ["identify inefficiencies", "increase cost", "reduce planning", "ignore data"],
  answer: "identify inefficiencies"
},
{
  question: "If material price increases, MPV is:",
  options: ["adverse", "favourable", "zero", "neutral"],
  answer: "adverse"
},
{
  question: "If actual usage is less than standard, usage variance is:",
  options: ["favourable", "adverse", "zero", "neutral"],
  answer: "favourable"
},
{
  question: "Total material variance =",
  options: ["price variance + usage variance", "sales − cost", "profit − cost", "cost − price"],
  answer: "price variance + usage variance"
},
{
  question: "Total labour variance =",
  options: ["rate variance + efficiency variance", "sales − cost", "profit − cost", "cost − price"],
  answer: "rate variance + efficiency variance"
},
{
  question: "If MPV GH¢500 adverse and MUV GH¢300 favourable, total variance is:",
  options: ["GH¢200 adverse", "GH¢800 favourable", "GH¢500", "GH¢300"],
  answer: "GH¢200 adverse"
},
{
  question: "If LRV GH¢1,000 adverse and LEV GH¢500 favourable, total labour variance is:",
  options: ["GH¢500 adverse", "GH¢1,500 favourable", "GH¢500 favourable", "GH¢1,000"],
  answer: "GH¢500 adverse"
},
{
  question: "Variance helps in:",
  options: ["performance evaluation", "increasing cost", "reducing output", "limiting planning"],
  answer: "performance evaluation"
},
{
  question: "Which factor causes adverse labour rate variance?",
  options: ["higher wage rate", "lower wage rate", "efficient labour", "low hours"],
  answer: "higher wage rate"
},
{
  question: "Which factor causes favourable usage variance?",
  options: ["efficient use of materials", "wastage", "high cost", "low output"],
  answer: "efficient use of materials"
},
{
  question: "Standard costing is most useful for:",
  options: ["cost control", "profit maximization only", "sales increase", "production only"],
  answer: "cost control"
},
{
  question: "Variance analysis is part of:",
  options: ["budgetary control", "financial accounting", "auditing", "taxation"],
  answer: "budgetary control"
},
{
  question: "If actual equals standard, variance is:",
  options: ["zero", "favourable", "adverse", "profit"],
  answer: "zero"
},
{
  question: "Effective variance analysis leads to:",
  options: ["better management decisions", "higher costs", "lower output", "inefficiency"],
  answer: "better management decisions"
},

{
  question: "Process costing is suitable for:",
  options: ["continuous production of identical units", "custom jobs", "batch production only", "services"],
  answer: "continuous production of identical units"
},
{
  question: "Equivalent units represent:",
  options: ["completed units in terms of finished output", "total units", "raw materials", "loss"],
  answer: "completed units in terms of finished output"
},
{
  question: "Work-in-progress refers to:",
  options: ["partially completed units", "finished goods", "raw materials", "waste"],
  answer: "partially completed units"
},
{
  question: "Normal loss is:",
  options: ["expected loss in production", "unexpected loss", "profit", "waste"],
  answer: "expected loss in production"
},
{
  question: "Abnormal loss is:",
  options: ["loss beyond expected", "normal loss", "profit", "expected loss"],
  answer: "loss beyond expected"
},
{
  question: "If input is 1,000 units and normal loss 10%, expected output is:",
  options: ["900 units", "1,000 units", "100 units", "800 units"],
  answer: "900 units"
},
{
  question: "If actual output is 850 units, abnormal loss is:",
  options: ["50 units", "100 units", "150 units", "0"],
  answer: "50 units"
},
{
  question: "If abnormal gain occurs, it means:",
  options: ["actual loss less than expected", "actual loss more", "profit", "no loss"],
  answer: "actual loss less than expected"
},
{
  question: "Process cost per unit is:",
  options: ["total cost / equivalent units", "units × cost", "cost × units", "profit / units"],
  answer: "total cost / equivalent units"
},
{
  question: "If total cost GH¢9,000 and output 900 units, cost per unit is:",
  options: ["GH¢10", "GH¢9", "GH¢8", "GH¢12"],
  answer: "GH¢10"
},
{
  question: "Equivalent units for materials (100% complete) =",
  options: ["total units", "half units", "zero", "cost"],
  answer: "total units"
},
{
  question: "If 200 units are 50% complete, equivalent units =",
  options: ["100 units", "200 units", "50 units", "150 units"],
  answer: "100 units"
},
{
  question: "Total equivalent units =",
  options: ["completed + equivalent WIP", "input only", "output only", "loss only"],
  answer: "completed + equivalent WIP"
},
{
  question: "If completed 800 units and WIP 200 units at 50%, equivalent units =",
  options: ["900 units", "800 units", "1,000 units", "850 units"],
  answer: "900 units"
},
{
  question: "If cost GH¢9,000 and equivalent units 900, cost per unit =",
  options: ["GH¢10", "GH¢9", "GH¢8", "GH¢12"],
  answer: "GH¢10"
},
{
  question: "Value of closing WIP =",
  options: ["equivalent units × cost per unit", "units × cost", "cost × output", "profit"],
  answer: "equivalent units × cost per unit"
},
{
  question: "If WIP equivalent units 100 and cost/unit GH¢10, WIP value is:",
  options: ["GH¢1,000", "GH¢500", "GH¢100", "GH¢2,000"],
  answer: "GH¢1,000"
},
{
  question: "Normal loss cost is:",
  options: ["absorbed by good units", "separate cost", "profit", "ignored"],
  answer: "absorbed by good units"
},
{
  question: "Abnormal loss is valued at:",
  options: ["cost per unit", "selling price", "zero", "market price"],
  answer: "cost per unit"
},
{
  question: "If abnormal loss 50 units and cost/unit GH¢10, value is:",
  options: ["GH¢500", "GH¢50", "GH¢100", "GH¢1,000"],
  answer: "GH¢500"
},
{
  question: "Process account records:",
  options: ["cost of each process", "sales", "profit", "cash"],
  answer: "cost of each process"
},
{
  question: "Input in process account is recorded on:",
  options: ["debit side", "credit side", "both", "none"],
  answer: "debit side"
},
{
  question: "Output is recorded on:",
  options: ["credit side", "debit side", "both", "none"],
  answer: "credit side"
},
{
  question: "Loss is recorded on:",
  options: ["credit side", "debit side", "both", "none"],
  answer: "credit side"
},
{
  question: "Gain is recorded on:",
  options: ["debit side", "credit side", "both", "none"],
  answer: "debit side"
},
{
  question: "Equivalent unit method helps to:",
  options: ["allocate cost accurately", "increase cost", "reduce output", "ignore WIP"],
  answer: "allocate cost accurately"
},
{
  question: "If cost increases and output same, cost per unit:",
  options: ["increases", "decreases", "remains same", "zero"],
  answer: "increases"
},
{
  question: "If output increases and cost same, cost per unit:",
  options: ["decreases", "increases", "same", "zero"],
  answer: "decreases"
},
{
  question: "Which method is used for partial completion?",
  options: ["equivalent units", "job costing", "batch costing", "contract costing"],
  answer: "equivalent units"
},
{
  question: "Process costing ensures:",
  options: ["accurate cost per unit", "high cost", "low output", "inefficiency"],
  answer: "accurate cost per unit"
},

{
  question: "Cost accounting records are maintained in:",
  options: ["cost ledger", "financial ledger", "sales ledger", "purchase ledger"],
  answer: "cost ledger"
},
{
  question: "The main purpose of cost bookkeeping is to:",
  options: ["record cost transactions systematically", "prepare final accounts", "audit accounts", "calculate tax"],
  answer: "record cost transactions systematically"
},
{
  question: "Stores ledger control account records:",
  options: ["materials", "labour", "overheads", "sales"],
  answer: "materials"
},
{
  question: "Wages control account records:",
  options: ["labour cost", "materials", "overheads", "sales"],
  answer: "labour cost"
},
{
  question: "Production overhead control account records:",
  options: ["indirect costs", "direct costs", "sales", "profit"],
  answer: "indirect costs"
},
{
  question: "Work-in-progress control account records:",
  options: ["cost of unfinished goods", "finished goods", "raw materials", "sales"],
  answer: "cost of unfinished goods"
},
{
  question: "Finished goods control account records:",
  options: ["cost of completed goods", "raw materials", "labour", "overheads"],
  answer: "cost of completed goods"
},
{
  question: "Cost of sales account shows:",
  options: ["cost of goods sold", "sales value", "profit", "expenses"],
  answer: "cost of goods sold"
},
{
  question: "In cost ledger, purchase of materials is:",
  options: ["debited to stores account", "credited to stores", "debited to wages", "credited to overhead"],
  answer: "debited to stores account"
},
{
  question: "Issue of materials to production is:",
  options: ["credited to stores account", "debited to stores", "credited to wages", "debited to sales"],
  answer: "credited to stores account"
},
{
  question: "Direct labour is debited to:",
  options: ["WIP account", "stores account", "overhead account", "sales"],
  answer: "WIP account"
},
{
  question: "Indirect labour is debited to:",
  options: ["overhead account", "WIP account", "stores account", "sales"],
  answer: "overhead account"
},
{
  question: "Overheads absorbed are:",
  options: ["debited to WIP", "credited to WIP", "debited to stores", "credited to wages"],
  answer: "debited to WIP"
},
{
  question: "Finished goods transferred from WIP is:",
  options: ["credited to WIP and debited to finished goods", "debited to WIP", "credited to stores", "debited to overhead"],
  answer: "credited to WIP and debited to finished goods"
},
{
  question: "Cost of goods sold is transferred to:",
  options: ["cost of sales account", "stores account", "WIP", "overhead"],
  answer: "cost of sales account"
},
{
  question: "Under-absorbed overhead is:",
  options: ["debited to costing P&L", "credited to costing P&L", "ignored", "transferred to sales"],
  answer: "debited to costing P&L"
},
{
  question: "Over-absorbed overhead is:",
  options: ["credited to costing P&L", "debited to costing P&L", "ignored", "added to WIP"],
  answer: "credited to costing P&L"
},
{
  question: "Costing profit and loss account shows:",
  options: ["profit or loss from cost records", "sales only", "materials", "labour"],
  answer: "profit or loss from cost records"
},
{
  question: "Control accounts help to:",
  options: ["summarize detailed transactions", "increase cost", "reduce output", "ignore records"],
  answer: "summarize detailed transactions"
},
{
  question: "Reconciliation statement compares:",
  options: ["cost profit and financial profit", "sales and cost", "assets and liabilities", "profit and loss"],
  answer: "cost profit and financial profit"
},
{
  question: "Difference between cost and financial profit may arise due to:",
  options: ["different valuation methods", "same records", "same method", "no difference"],
  answer: "different valuation methods"
},
{
  question: "Financial accounts include:",
  options: ["non-cost items", "cost items only", "labour only", "materials only"],
  answer: "non-cost items"
},
{
  question: "Cost accounts exclude:",
  options: ["purely financial items", "materials", "labour", "overhead"],
  answer: "purely financial items"
},
{
  question: "Integrated accounting system combines:",
  options: ["cost and financial accounts", "sales and purchase", "labour and materials", "profit and loss"],
  answer: "cost and financial accounts"
},
{
  question: "Non-integrated system means:",
  options: ["separate cost and financial records", "combined system", "single ledger", "no records"],
  answer: "separate cost and financial records"
},
{
  question: "If cost profit GH¢10,000 and financial profit GH¢12,000, difference is:",
  options: ["GH¢2,000", "GH¢10,000", "GH¢12,000", "GH¢5,000"],
  answer: "GH¢2,000"
},
{
  question: "Which item appears only in financial accounts?",
  options: ["interest income", "direct labour", "materials", "overhead"],
  answer: "interest income"
},
{
  question: "Which item appears in cost accounts?",
  options: ["materials cost", "dividends", "interest", "tax"],
  answer: "materials cost"
},
{
  question: "Cost ledger ensures:",
  options: ["accurate cost recording", "profit maximization", "sales increase", "tax reduction"],
  answer: "accurate cost recording"
},
{
  question: "Proper bookkeeping helps to:",
  options: ["control cost effectively", "increase errors", "reduce control", "ignore cost"],
  answer: "control cost effectively"
},

{
  question: "A product sells at GH¢25 with variable cost GH¢15. Contribution per unit is:",
  options: ["GH¢10", "GH¢15", "GH¢25", "GH¢5"],
  answer: "GH¢10"
},
{
  question: "If fixed cost GH¢20,000 and contribution/unit GH¢10, BEP units:",
  options: ["2,000 units", "1,000 units", "500 units", "4,000 units"],
  answer: "2,000 units"
},
{
  question: "A company produces 1,000 units, fixed cost GH¢10,000, variable GH¢8/unit. Total cost:",
  options: ["GH¢18,000", "GH¢8,000", "GH¢10,000", "GH¢20,000"],
  answer: "GH¢18,000"
},
{
  question: "If sales GH¢50,000 and contribution GH¢20,000, P/V ratio is:",
  options: ["40%", "50%", "20%", "60%"],
  answer: "40%"
},
{
  question: "If P/V ratio 40% and fixed cost GH¢12,000, BEP sales:",
  options: ["GH¢30,000", "GH¢20,000", "GH¢40,000", "GH¢12,000"],
  answer: "GH¢30,000"
},
{
  question: "A worker earns GH¢12/hour for 40 hours and GH¢18/hour for 10 overtime hours. Total wage:",
  options: ["GH¢660", "GH¢600", "GH¢720", "GH¢500"],
  answer: "GH¢660"
},
{
  question: "EOQ increases when:",
  options: ["demand increases", "holding cost increases", "ordering cost decreases", "storage cost increases"],
  answer: "demand increases"
},
{
  question: "If demand 1,000 units, ordering cost GH¢50, holding GH¢5, EOQ:",
  options: ["141 units", "200 units", "100 units", "300 units"],
  answer: "141 units"
},
{
  question: "If reorder level 800 units, usage 100/day, lead time:",
  options: ["8 days", "10 days", "5 days", "6 days"],
  answer: "8 days"
},
{
  question: "If cost GH¢15,000 and profit 20%, selling price:",
  options: ["GH¢18,000", "GH¢15,000", "GH¢20,000", "GH¢12,000"],
  answer: "GH¢18,000"
},
{
  question: "If output 1,200 units and cost GH¢24,000, cost/unit:",
  options: ["GH¢20", "GH¢24", "GH¢18", "GH¢30"],
  answer: "GH¢20"
},
{
  question: "If actual cost GH¢5,500 and standard GH¢5,000, variance:",
  options: ["GH¢500 adverse", "GH¢500 favourable", "GH¢5,000", "GH¢5,500"],
  answer: "GH¢500 adverse"
},
{
  question: "If SP GH¢6, AP GH¢5, AQ 1,000 units, MPV:",
  options: ["GH¢1,000 favourable", "GH¢1,000 adverse", "GH¢6,000", "GH¢5,000"],
  answer: "GH¢1,000 favourable"
},
{
  question: "If SH 500, AH 600, SR GH¢10, labour efficiency variance:",
  options: ["GH¢1,000 adverse", "GH¢1,000 favourable", "GH¢5,000", "GH¢6,000"],
  answer: "GH¢1,000 adverse"
},
{
  question: "If overhead GH¢10,000 and hours 2,500, OAR:",
  options: ["GH¢4/hour", "GH¢5/hour", "GH¢3/hour", "GH¢6/hour"],
  answer: "GH¢4/hour"
},
{
  question: "If absorbed GH¢12,000 and actual GH¢10,000, over-absorption:",
  options: ["GH¢2,000", "GH¢1,000", "GH¢3,000", "GH¢500"],
  answer: "GH¢2,000"
},
{
  question: "If contribution GH¢15,000 and fixed GH¢10,000, profit:",
  options: ["GH¢5,000", "GH¢10,000", "GH¢15,000", "GH¢25,000"],
  answer: "GH¢5,000"
},
{
  question: "If sales GH¢40,000 and BEP GH¢25,000, margin of safety:",
  options: ["GH¢15,000", "GH¢25,000", "GH¢40,000", "GH¢10,000"],
  answer: "GH¢15,000"
},
{
  question: "If materials GH¢6,000, labour GH¢4,000, overhead GH¢5,000, total cost:",
  options: ["GH¢15,000", "GH¢10,000", "GH¢11,000", "GH¢9,000"],
  answer: "GH¢15,000"
},
{
  question: "If WIP 200 units at 50%, equivalent units:",
  options: ["100 units", "200 units", "50 units", "150 units"],
  answer: "100 units"
},
{
  question: "If input 1,000 units and normal loss 10%, output:",
  options: ["900 units", "1,000 units", "800 units", "100 units"],
  answer: "900 units"
},
{
  question: "If actual output 920 units, abnormal gain:",
  options: ["20 units", "80 units", "100 units", "0"],
  answer: "20 units"
},
{
  question: "If cost GH¢9,000 and equivalent units 900, cost/unit:",
  options: ["GH¢10", "GH¢9", "GH¢8", "GH¢12"],
  answer: "GH¢10"
},
{
  question: "If WIP 100 units, cost/unit GH¢10, value:",
  options: ["GH¢1,000", "GH¢500", "GH¢100", "GH¢2,000"],
  answer: "GH¢1,000"
},
{
  question: "If gross wage GH¢600 and deductions GH¢150, net wage:",
  options: ["GH¢450", "GH¢600", "GH¢300", "GH¢500"],
  answer: "GH¢450"
},
{
  question: "If batch cost GH¢8,000 and units 400, cost/unit:",
  options: ["GH¢20", "GH¢25", "GH¢15", "GH¢30"],
  answer: "GH¢20"
},
{
  question: "If sales increase but profit decreases, reason:",
  options: ["cost increase", "demand increase", "price increase", "efficiency"],
  answer: "cost increase"
},
{
  question: "If fixed cost increases, BEP:",
  options: ["increases", "decreases", "remains same", "zero"],
  answer: "increases"
},
{
  question: "If contribution increases, BEP:",
  options: ["decreases", "increases", "same", "zero"],
  answer: "decreases"
},
{
  question: "Accurate costing helps in:",
  options: ["pricing decisions", "reducing output", "increasing cost", "ignoring profit"],
  answer: "pricing decisions"
},

{
  question: "A product sells at GH¢30. Variable cost is GH¢18. Fixed cost GH¢24,000. BEP (units):",
  options: ["2,000", "1,500", "1,000", "3,000"],
  answer: "2,000"
},
{
  question: "If sales 3,000 units, margin of safety:",
  options: ["1,000 units", "2,000 units", "500 units", "3,000 units"],
  answer: "1,000 units"
},
{
  question: "P/V ratio for above:",
  options: ["40%", "60%", "50%", "30%"],
  answer: "40%"
},
{
  question: "If selling price drops to GH¢25, contribution becomes:",
  options: ["GH¢7", "GH¢12", "GH¢10", "GH¢5"],
  answer: "GH¢7"
},
{
  question: "New BEP:",
  options: ["3,429 units", "2,000 units", "3,000 units", "1,500 units"],
  answer: "3,429 units"
},
{
  question: "If material price increases by GH¢2/unit, MPV (AQ=1,000):",
  options: ["GH¢2,000 adverse", "GH¢2,000 favourable", "GH¢1,000", "GH¢500"],
  answer: "GH¢2,000 adverse"
},
{
  question: "If usage reduces by 200 units, SP GH¢5, MUV:",
  options: ["GH¢1,000 favourable", "GH¢1,000 adverse", "GH¢5,000", "GH¢200"],
  answer: "GH¢1,000 favourable"
},
{
  question: "If labour rate rises GH¢3/hour, AH 400, LRV:",
  options: ["GH¢1,200 adverse", "GH¢1,200 favourable", "GH¢400", "GH¢3,000"],
  answer: "GH¢1,200 adverse"
},
{
  question: "If AH exceeds SH by 100 hours, SR GH¢10, LEV:",
  options: ["GH¢1,000 adverse", "GH¢1,000 favourable", "GH¢500", "GH¢2,000"],
  answer: "GH¢1,000 adverse"
},
{
  question: "If overhead GH¢15,000, hours 3,000, OAR:",
  options: ["GH¢5", "GH¢4", "GH¢6", "GH¢3"],
  answer: "GH¢5"
},
{
  question: "If absorbed GH¢16,000 vs actual GH¢15,000:",
  options: ["GH¢1,000 over-absorbed", "GH¢1,000 under", "GH¢2,000", "GH¢500"],
  answer: "GH¢1,000 over-absorbed"
},
{
  question: "If WIP 300 units at 40%, equivalent units:",
  options: ["120", "300", "150", "200"],
  answer: "120"
},
{
  question: "If total cost GH¢12,000, equivalent units 1,200, cost/unit:",
  options: ["GH¢10", "GH¢12", "GH¢8", "GH¢6"],
  answer: "GH¢10"
},
{
  question: "If abnormal loss 80 units at GH¢10/unit:",
  options: ["GH¢800", "GH¢80", "GH¢1,000", "GH¢500"],
  answer: "GH¢800"
},
{
  question: "If normal loss 10% of 1,000 units:",
  options: ["100 units", "900 units", "50 units", "200 units"],
  answer: "100 units"
},
{
  question: "If actual output 920 units, abnormal gain:",
  options: ["20 units", "80 units", "100 units", "0"],
  answer: "20 units"
},
{
  question: "If EOQ increases, likely cause:",
  options: ["increase in demand", "increase in holding cost", "lower demand", "lower ordering cost"],
  answer: "increase in demand"
},
{
  question: "If reorder level 600, usage 75/day, lead time:",
  options: ["8 days", "6 days", "10 days", "5 days"],
  answer: "8 days"
},
{
  question: "If labour cost GH¢9,000 for 600 units, cost/unit:",
  options: ["GH¢15", "GH¢10", "GH¢12", "GH¢18"],
  answer: "GH¢15"
},
{
  question: "If batch cost GH¢12,000, units 600:",
  options: ["GH¢20", "GH¢25", "GH¢15", "GH¢18"],
  answer: "GH¢20"
},
{
  question: "If contribution GH¢25,000 and fixed GH¢20,000:",
  options: ["GH¢5,000 profit", "GH¢5,000 loss", "GH¢20,000", "GH¢25,000"],
  answer: "GH¢5,000 profit"
},
{
  question: "If sales GH¢80,000 and BEP GH¢50,000, MOS:",
  options: ["GH¢30,000", "GH¢50,000", "GH¢80,000", "GH¢20,000"],
  answer: "GH¢30,000"
},
{
  question: "If P/V ratio 50%, sales GH¢60,000, contribution:",
  options: ["GH¢30,000", "GH¢20,000", "GH¢60,000", "GH¢15,000"],
  answer: "GH¢30,000"
},
{
  question: "If fixed cost doubles, BEP:",
  options: ["doubles", "halves", "same", "zero"],
  answer: "doubles"
},
{
  question: "If variable cost rises, contribution:",
  options: ["falls", "rises", "same", "zero"],
  answer: "falls"
},
{
  question: "If selling price rises, P/V ratio:",
  options: ["increases", "decreases", "same", "zero"],
  answer: "increases"
},
{
  question: "If cost/unit falls with output, indicates:",
  options: ["economies of scale", "loss", "inefficiency", "fixed cost rise"],
  answer: "economies of scale"
},
{
  question: "If overhead under-absorbed:",
  options: ["actual > absorbed", "absorbed > actual", "equal", "zero"],
  answer: "actual > absorbed"
},
{
  question: "If cost control improves:",
  options: ["profit increases", "profit decreases", "cost rises", "output falls"],
  answer: "profit increases"
},
{
  question: "Best decision tool in costing:",
  options: ["marginal costing", "financial accounting", "auditing", "taxation"],
  answer: "marginal costing"
},

{
  question: "A company maintains very high inventory levels to avoid stockouts, but costs keep rising. The main issue is:",
  options: ["poor inventory control", "high demand", "effective planning", "strong supply chain"],
  answer: "poor inventory control"
},
{
  question: "A firm experiences frequent machine breakdowns leading to increased overhead costs. This reflects:",
  options: ["inefficient maintenance system", "high labour efficiency", "good planning", "low production cost"],
  answer: "inefficient maintenance system"
},
{
  question: "A business continues to use outdated costing methods despite market changes. This indicates:",
  options: ["lack of innovation in cost control", "strong management", "high profitability", "efficient costing"],
  answer: "lack of innovation in cost control"
},
{
  question: "A company produces large output but still records high unit cost. The likely reason is:",
  options: ["inefficient resource utilization", "economies of scale", "high demand", "low fixed cost"],
  answer: "inefficient resource utilization"
},
{
  question: "A firm ignores small abnormal losses in production. The implication is:",
  options: ["distorted cost information", "accurate costing", "increased profit", "efficient production"],
  answer: "distorted cost information"
},
{
  question: "A company uses only financial accounting records for internal decisions. This suggests:",
  options: ["lack of cost accounting system", "strong control", "efficient planning", "high accuracy"],
  answer: "lack of cost accounting system"
},
{
  question: "A business sets unrealistic standard costs. This will likely result in:",
  options: ["misleading variance analysis", "accurate cost control", "high efficiency", "improved productivity"],
  answer: "misleading variance analysis"
},
{
  question: "A company consistently records adverse material usage variance. The main issue is:",
  options: ["inefficient use of materials", "low material price", "high labour efficiency", "good planning"],
  answer: "inefficient use of materials"
},
{
  question: "A firm experiences favourable labour efficiency variance but poor output quality. This indicates:",
  options: ["speed over quality", "effective production", "high standard cost", "low labour cost"],
  answer: "speed over quality"
},
{
  question: "A company fails to separate direct and indirect costs. This leads to:",
  options: ["inaccurate product costing", "higher profit", "better pricing", "efficient planning"],
  answer: "inaccurate product costing"
},
{
  question: "A firm uses a single overhead absorption rate for all departments. This may cause:",
  options: ["cost distortion", "accurate costing", "better allocation", "low overhead"],
  answer: "cost distortion"
},
{
  question: "A company has high fixed costs but low contribution. The risk is:",
  options: ["high break-even point", "low break-even point", "high profit", "low cost"],
  answer: "high break-even point"
},
{
  question: "A firm increases selling price but demand falls significantly. This shows:",
  options: ["price elasticity effect", "cost control", "high contribution", "low competition"],
  answer: "price elasticity effect"
},
{
  question: "A company uses FIFO during rising prices. This results in:",
  options: ["lower cost of sales", "higher cost of sales", "no change", "zero profit"],
  answer: "lower cost of sales"
},
{
  question: "A business uses average costing in volatile markets. The benefit is:",
  options: ["price smoothing", "higher profit", "low cost", "high efficiency"],
  answer: "price smoothing"
},
{
  question: "A company fails to update stock records regularly. This leads to:",
  options: ["poor inventory decisions", "high efficiency", "low cost", "accurate planning"],
  answer: "poor inventory decisions"
},
{
  question: "A firm experiences frequent stockouts despite high demand. The likely cause is:",
  options: ["poor reorder level setting", "high EOQ", "low demand", "high cost"],
  answer: "poor reorder level setting"
},
{
  question: "A business applies marginal costing for decision-making. The key advantage is:",
  options: ["focus on contribution", "focus on total cost", "ignores profit", "reduces output"],
  answer: "focus on contribution"
},
{
  question: "A firm relies heavily on fixed budgets in a changing environment. This leads to:",
  options: ["inflexible planning", "accurate control", "high efficiency", "better forecasting"],
  answer: "inflexible planning"
},
{
  question: "A company uses flexible budgeting effectively. This improves:",
  options: ["performance evaluation", "cost increase", "profit reduction", "inefficiency"],
  answer: "performance evaluation"
},
{
  question: "A firm fails to reconcile cost and financial accounts. This suggests:",
  options: ["lack of control", "accurate records", "efficient system", "strong accounting"],
  answer: "lack of control"
},
{
  question: "A business ignores overhead under-absorption. This leads to:",
  options: ["understated cost", "accurate profit", "higher efficiency", "low cost"],
  answer: "understated cost"
},
{
  question: "A company invests in training workers. The likely outcome is:",
  options: ["improved efficiency", "higher cost only", "low output", "high waste"],
  answer: "improved efficiency"
},
{
  question: "A firm uses job costing in mass production. This results in:",
  options: ["inefficient costing system", "accurate costing", "low cost", "high output"],
  answer: "inefficient costing system"
},
{
  question: "A company produces identical goods but uses job costing. This shows:",
  options: ["wrong costing method", "accurate costing", "low cost", "efficient planning"],
  answer: "wrong costing method"
},
{
  question: "A firm experiences high labour turnover. The likely effect is:",
  options: ["increased training cost", "high productivity", "low cost", "strong workforce"],
  answer: "increased training cost"
},
{
  question: "A business uses overtime excessively. This may result in:",
  options: ["higher labour cost", "lower cost", "high efficiency", "low output"],
  answer: "higher labour cost"
},
{
  question: "A company ignores idle time. This leads to:",
  options: ["hidden inefficiencies", "accurate costing", "low cost", "high profit"],
  answer: "hidden inefficiencies"
},
{
  question: "A firm focuses only on cost reduction. This may lead to:",
  options: ["quality reduction", "higher profit always", "strong brand", "high demand"],
  answer: "quality reduction"
},
{
  question: "A business adopts automation. The main benefit is:",
  options: ["cost efficiency", "higher labour cost", "low output", "reduced production"],
  answer: "cost efficiency"
},
{
  question: "A company ignores abnormal gain. This results in:",
  options: ["incorrect cost allocation", "accurate profit", "high efficiency", "low cost"],
  answer: "incorrect cost allocation"
},
{
  question: "A firm applies standard costing incorrectly. This leads to:",
  options: ["misleading decisions", "accurate planning", "high profit", "low cost"],
  answer: "misleading decisions"
},
{
  question: "A business fails to monitor variances regularly. This results in:",
  options: ["poor cost control", "high efficiency", "low cost", "better planning"],
  answer: "poor cost control"
},
{
  question: "A company increases output without controlling cost. The likely result is:",
  options: ["reduced profitability", "higher profit", "low cost", "high efficiency"],
  answer: "reduced profitability"
},
{
  question: "A firm with poor cost records will likely:",
  options: ["make wrong decisions", "increase profit", "reduce cost", "improve efficiency"],
  answer: "make wrong decisions"
},
{
  question: "A business adopts correct costing methods. This leads to:",
  options: ["accurate pricing", "high cost", "low output", "inefficiency"],
  answer: "accurate pricing"
},
{
  question: "A company fails to control materials properly. This results in:",
  options: ["material wastage", "high efficiency", "low cost", "strong control"],
  answer: "material wastage"
},
{
  question: "A firm ignores cost information in decision-making. This leads to:",
  options: ["poor business decisions", "high profit", "low cost", "better planning"],
  answer: "poor business decisions"
},
{
  question: "A business focuses on contribution rather than profit. This is typical of:",
  options: ["marginal costing", "financial accounting", "auditing", "taxation"],
  answer: "marginal costing"
},
{
  question: "A company improves cost control systems. The main outcome is:",
  options: ["better efficiency and profitability", "higher cost", "lower output", "reduced planning"],
  answer: "better efficiency and profitability"
}
];

export default costAccountingQuestions;